// src/pages/Catalog/components/CategoryModal.js
import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../../services/api";
import toastError from "../../../errors/toastError";
import { i18n } from "../../../translate/i18n";

const CategoryModal = ({ open, onClose, categoryId, onSave }) => {
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    const fetchCategory = async () => {
      if (!categoryId) return;
      try {
        setLoading(true);
        const { data } = await api.get(`/categories/${categoryId}`);
        setCategory(data);
        setLoading(false);
      } catch (err) {
        toastError(err);
        setLoading(false);
      }
    };
    fetchCategory();
  }, [categoryId]);

  useEffect(() => {
    if (!open) {
      setCategory({
        name: "",
        description: "",
      });
    }
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let data;
      
      if (categoryId) {
        const response = await api.put(`/categories/${categoryId}`, category);
        data = response.data;
        toast.success("Categoría actualizada con éxito");
      } else {
        const response = await api.post("/categories", category);
        data = response.data;
        toast.success("Categoría creada con éxito");
      }

      if (onSave) onSave(data);
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle id="form-dialog-title">
          {categoryId ? i18n.t("categories.editTitle", "Editar Categoría") : i18n.t("categories.newTitle", "Nueva Categoría")}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoFocus
                label={i18n.t("categories.form.name", "Nombre de la categoría")}
                name="name"
                value={category.name}
                onChange={handleChange}
                fullWidth
                required
                disabled={loading}
                variant="outlined"
                margin="dense"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={i18n.t("categories.form.description", "Descripción")}
                name="description"
                value={category.description}
                onChange={handleChange}
                fullWidth
                multiline
                rows={4}
                disabled={loading}
                variant="outlined"
                margin="dense"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="default" disabled={loading}>
            {i18n.t("categories.buttons.cancel", "Cancelar")}
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : categoryId ? (
              i18n.t("categories.buttons.update", "Actualizar")
            ) : (
              i18n.t("categories.buttons.create", "Crear")
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CategoryModal;